export const REDIRECT_TO_NEW_JOBSEEKER_REQUEST = 'REDIRECT_TO_NEW_JOBSEEKER_REQUEST'
export const REDIRECT_TO_NEW_JOBSEEKER_SUCCESS = 'REDIRECT_TO_NEW_JOBSEEKER_SUCCESS'
export const REDIRECT_TO_NEW_JOBSEEKER_FAILED = 'REDIRECT_TO_NEW_JOBSEEKER_FAILED'
